export const credits = {
  // Must be placed in the order it is desired they appear in the credits
  roles: {
    1: "Creator",
    2: "Technical Architect",
    3: "Lead Developer",
    4: "Android Developer",
    5: "Steam Developer",
    6: "Library Developer",
    7: "Developer",
    8: "Lead Design Consultant",
    9: "Design Consultant",
    10: "Writer",
    11: "Achievement Art",
    12: "Modal Maker, Lady Taker, Pie Baker",
    13: "Lurker Tester",
    14: "Web Tester",
    15: "Android Tester",
  },

  // Each person must have a name and at least one role (the index of the desired role in roles). They can also have a
  // second name, which will appear in parentheses besides their first.
  people: [
    {
      name: "Hevipelle",
      name2: "Ivar Kerajärvi",
      roles: 1
    }, {
      name: "Razenpok",
      name2: "Andrei Andreev",
      roles: 2
    }, {
      name: "garnet420",
      roles: 3
    }, {
      name: "Omsi",
      roles: [3, 11]
    }, {
      name: "SpectralFlame",
      name2: "Christopher Yip",
      roles: 3
    }, {
      name: "WaitingIdly",
      roles: [3, 7, 9, 14, 15]
    }, {
      name: "kajfik",
      name2: "Jakub Kajfosz",
      roles: 4
    }, {
      name: "Makopaz",
      name2: "Zack Stein",
      roles: 5
    }, {
      name: "Patashu",
      roles: [6, 7, 14]
    }, {
      name: "Dan",
      roles: [7, 14]
    }, {
      name: "earth",
      name2: "Jace Royer",
      roles: [7, 12, 14, 15]
    }, {
      name: "Hira",
      roles: [7, 14, 15]
    }, {
      name: "IkerStream",
      name2: "Iker de Aguirre",
      roles: [7, 14]
    }, {
      name: "L4R5",
      name2: "Lars Wolf",
      roles: [7, 14, 15]
    }, {
      name: "Pichusuperlover",
      roles: [7, 9, 14]
    }, {
      name: "realrapidjazz",
      roles: [7, 8, 10]
    }, {
      name: "Scarlet",
      roles: [7, 14, 15]
    }, {
      name: "slabdrill",
      roles: 7
    }, {
      name: "Acamaeda",
      roles: [9, 14]
    }, {
      name: "Dravitar",
      name2: "Alex Henderson",
      roles: 13
    }, {
      name: "Aesis",
      roles: 14
    }, {
      name: "AFYINEE",
      name2: "Gabriel HADDAG",
      roles: 14
    }, {
      name: "Alexitato",
      roles: 14
    }, {
      name: "Anno",
      roles: 14
    }, {
      name: "Myresa Exina",
      roles: [14, 15]
    }, {
      name: "ArrowBounce",
      name2: "Timothy Su",
      roles: 14
    }, {
      name: "Birb",
      name2: "Kelsey Black",
      roles: 14
    }, {
      name: "Boo",
      name2: "Jean-Christophe Bourgault",
      roles: 14
    }, {
      name: "CaptainGalaxy",
      name2: "Ovidijus Točelis",
      roles: 14
    }, {
      name: "ChaoticHans",
      roles: [14, 15]
    }, {
      name: "cubic frog",
      roles: 14
    }, {
      name: "dankesehr",
      roles: 14
    }, {
      name: "Davixx",
      name2: "Davide Fedele",
      roles: 14
    }, {
      name: "Empireus",
      roles: 14
    }, {
      name: "GirixK",
      name2: "Nikola Jelinčić",
      roles: [14, 15]
    }, {
      name: "GoldenTritium",
      roles: [14, 15]
    }, {
      name: "Kael",
      roles: 14
    }, {
      name: "Lynn",
      roles: 14
    }, {
      name: "Merp",
      roles: 14
    }, {
      name: "philipebreaker",
      name2: "Philipe",
      roles: 14
    }, {
      name: "Phillip Marshall",
      roles: 14
    }, {
      name: "Phoebe",
      roles: 14
    }, {
      name: "Reda Kotob",
      roles: 14
    }, {
      name: "Saturnus",
      roles: [14, 10]
    }, {
      name: "SereKabii",
      roles: 14
    }, {
      name: "Sheer",
      roles: 14
    }, {
      name: "sirusi",
      name2: "Vinícius Oliveira Martins",
      roles: 14
    }, {
      name: "Spanosa",
      name2: "Jared K",
      roles: 14
    }, {
      name: "Sparticle999",
      roles: 14
    }, {
      name: "SpicyCrusader13",
      roles: [14, 15]
    }, {
      name: "Storm",
      roles: 14
    }, {
      name: "SzyszakS",
      roles: 14
    }, {
      name: "Tacitus",
      roles: 14
    }, {
      name: "Typh",
      roles: 14
    }, {
      name: "Vnge",
      name2: "Ben Parrish",
      roles: [14, 15]
    }, {
      name: "Xemadus",
      name2: "Jonathan Gibson",
      roles: 14
    }, {
      name: "Young Woo Joo",
      roles: 14
    }, {
      name: "Zipi",
      roles: 14
    }, {
      name: "about:blank",
      roles: 15
    }, {
      name: "ÆiOuF",
      roles: 15
    }, {
      name: "Akirious",
      roles: 15
    }, {
      name: "Anjinho01",
      roles: 15
    }, {
      name: "Anthios",
      roles: 15
    }, {
      name: "Aubrey Ark",
      roles: 15
    }, {
      name: "Auti",
      name2: "Lucia Tolle",
      roles: 15
    }, {
      name: "Buck",
      roles: 15
    }, {
      name: "Barrin84",
      roles: 15
    }, {
      name: "Calmcat",
      roles: 15
    }, {
      name: "ChizuX",
      roles: 15
    }, {
      name: "Circle",
      roles: 15
    }, {
      name: "Crinkly Weasel",
      name2: "Aaryan Sarawgi",
      roles: 15
    }, {
      name: "Daniella",
      roles: 15
    }, {
      name: "DarthDie",
      name2: "Briar Bowser",
      roles: 15
    }, {
      name: "ElPopote83",
      roles: 15
    }, {
      name: "Epsilon",
      name2: "Coolguystorm",
      roles: 15
    }, {
      name: "Firecracker",
      roles: 15
    }, {
      name: "Gaunter",
      roles: 15
    }, {
      name: "Gimmick",
      roles: 15
    }, {
      name: "HarrisL2",
      roles: 15
    }, {
      name: "Hellbach",
      name2: "Asher Günther",
      roles: 15
    }, {
      name: "hen-ben",
      name2: "Henry Ellenberg",
      roles: 15
    }, {
      name: "ImpossibleSalsa",
      roles: 15
    }, {
      name: "JayM#1872",
      name2: "Jay McGee",
      roles: 15
    }, {
      name: "Johanniklas",
      name2: "Jan-Niklas Petersen",
      roles: 15
    }, {
      name: "Joseph Micheli",
      roles: 15
    }, {
      name: "kaislash",
      name2: "Lily",
      roles: 15
    }, {
      name: "Kirku",
      name2: "Fabian Makowski",
      roles: 15
    }, {
      name: "Kirin",
      name2: "Arthur",
      roles: 15
    }, {
      name: "Klötzchen",
      roles: 15
    }, {
      name: "L5racer",
      roles: 15
    }, {
      name: "Marshmallow",
      roles: 15
    }, {
      name: "HyperionMike",
      name2: "Miikael Siitan",
      roles: 15
    }, {
      name: "Mirai",
      roles: 15
    }, {
      name: "Monoma",
      name2: "ARoman Ruiz",
      roles: 15
    }, {
      name: "Nani",
      roles: 15
    }, {
      name: "Neo",
      name2: "Joon",
      roles: 15
    }, {
      name: "netweak",
      roles: 15
    }, {
      name: "NiZeKiHo",
      name2: "DominusDane",
      roles: 15
    }, {
      name: "NotBrewst",
      name2: "Luc Leblanc",
      roles: 15
    }, {
      name: "opdollar",
      name2: "Zane Coole",
      roles: 15
    }, {
      name: "Pavlxiiv",
      roles: 15
    }, {
      name: "coffeeflake",
      roles: 15
    }, {
      name: "Razor",
      roles: 15
    }, {
      name: "Razvan Cercel",
      roles: 15
    }, {
      name: "ReacTivity",
      roles: 15
    }, {
      name: "Reaxt",
      name2: "Rea Koehler",
      roles: 15
    }, {
      name: "Ruins",
      roles: 15
    }, {
      name: "Rukimix",
      roles: 15
    }, {
      name: "shadowevil",
      roles: 15
    }, {
      name: "Skunky",
      name2: "Lukas",
      roles: 15
    }, {
      name: "Snaeky",
      roles: 15
    }, {
      name: "Socks",
      name2: "Hannah Pocks",
      roles: 15
    }, {
      name: "Sweets the Alien",
      roles: 15
    }, {
      name: "Tables",
      roles: 15,
    }, {
      name: "Taylor Reeves",
      roles: 15
    }, {
      name: "TheAhmex",
      roles: 15
    }, {
      name: "The Trust Melon",
      roles: 15
    }, {
      name: "Tim Wong",
      roles: 15
    }, {
      name: "tragedt",
      name2: "Ethan Manninen",
      roles: 15
    }, {
      name: "tui sapo",
      roles: 15
    }, {
      name: "Valentine Clarissa Alanis Star Z",
      roles: 15
    }, {
      name: "vanadium_void",
      roles: 15
    }, {
      name: "X3N0_32",
      roles: 15
    }, {
      name: "ZylaKat",
      name2: "Katherine Goforth-Harbin",
      roles: 15
    }, {
      name: "Jedall",
      roles: 15
    }, {
      name: "Lapis",
      roles: 15
    }, {
      name: "Guimora",
      roles: 15
    }, {
      name: "Neowo",
      name2: "Neo Mitchell",
      roles: 15
    }, {
      name: "AshTheDinosaur",
      roles: 15
    }, {
      name: "Annyeong1",
      name2: "Jeeho Yoon",
      roles: 15
    }, {
      name: "Dedzuka",
      roles: 15
    }, {
      name: "Something",
      name2: "Sushi",
      roles: 15
    }, {
      name: "Viola",
      roles: 15
    }, {
      name: "Luna van Yeethoven",
      roles: 15
    }, {
      name: "Lotocion",
      roles: 15
    }, {
      name: "Merlyn",
      roles: 15
    }, {
      name: "Tilly",
      roles: 15
    }, {
      name: "Sauer",
      name2: "Matt",
      roles: 15
    }, {
      name: "PtigaD",
      roles: 15
    }, {
      name: "Aleame",
      roles: 15
    }, {
      name: "GFADE00",
      roles: 15
    }, {
      name: "Amity Emily",
      roles: 15
    }, {
      name: "BsonHK",
      roles: 15
    }, {
      name: "Angel",
      roles: 15
    }, {
      name: "OhBrod",
      roles: 15
    }, {
      name: "sxy62106210",
      roles: 15
    }, {
      name: "cyxw",
      roles: 15
    }, {
      name: "Cosmic_Fyre",
      roles: 15
    }, {
      name: "The Cube Dude",
      roles: 15
    }, {
      name: "Tias",
      name2: "Tim Stanglow",
      roles: 15
    }, {
      name: "Rad Cooldude",
      roles: 15
    }, {
      name: "DataBitMC",
      roles: 15
    }, {
      name: "Pizzalover04",
      name2: "Zanpaulco",
      roles: 15
    }, {
      name: "Airakogi",
      roles: 15
    }
  ]
};

credits.roles.count = Object.keys(credits.roles).length;
